var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var reduceSamples = require('./utils/reduceSamples');

var breathe = require('./utils/breathe'); //Smoothens contrast between samples by averaging the specified number of them


module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv, _ref) {
    var smooth, repeatSticky, result, key, k, samples, newSamples, i, ins, out, newSample;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            smooth = _ref.smooth, repeatSticky = _ref.repeatSticky;

            try {
              result = JSON.parse(JSON.stringify(klv));
            } catch (error) {
              result = klv;
            } //Loop devices and streams


            _context.t0 = _regeneratorRuntime.keys(result);

          case 3:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 19;
              break;
            }

            key = _context.t1.value;

            if (!result[key].streams) {
              _context.next = 17;
              break;
            }

            _context.t2 = _regeneratorRuntime.keys(result[key].streams);

          case 7:
            if ((_context.t3 = _context.t2()).done) {
              _context.next = 17;
              break;
            }

            k = _context.t3.value;
            _context.next = 11;
            return breathe();

          case 11:
            //Gather samples
            samples = result[key].streams[k].samples;
            newSamples = []; //Loop until the end of the array

            if (samples) {
              for (i = 0; i < samples.length; i++) {
                ins = Math.max(0, i - smooth);
                out = Math.min(i + smooth + 1, samples.length);
                newSample = reduceSamples(samples.slice(ins, out)); //Preserve original times

                if (samples[i].cts != null) newSample.cts = samples[i].cts;
                if (samples[i].date != null) newSample.date = samples[i].date; //Preserve original sticky

                if (!repeatSticky) {
                  delete newSample.sticky;
                  if (samples[i].sticky) newSample.sticky = samples[i].sticky;
                }

                newSamples.push(newSample);
              }
            } //Replace samples with smooth ones


            result[key].streams[k].samples = newSamples;
            _context.next = 7;
            break;

          case 17:
            _context.next = 3;
            break;

          case 19:
            return _context.abrupt("return", result);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();